import { render } from "./NftcosmosView.vue?vue&type=template&id=642fcdb8"
import script from "./NftcosmosView.vue?vue&type=script&lang=js"
export * from "./NftcosmosView.vue?vue&type=script&lang=js"

import "./NftcosmosView.vue?vue&type=style&index=0&id=642fcdb8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__